import { type PropsWithChildren } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';

export const ViewContainer = ({ children }: PropsWithChildren) => {
  return (
    <Box
      width="100%"
      height="100%"
      data-testid="presentation-container"
      alignItems="flex-end"
      flexDirection="row"
      justifyContent="center"
    >
      {children}
    </Box>
  );
};
